




































import Vue from 'vue';
import {Icon} from "@/helpers/icons";
import {Component, Emit, Prop} from "vue-property-decorator";
import AsiBtn from "@/components/common/AsiBtn.vue";
import AsiFadeTransition from "@/components/common/AsiFadeTransition.vue";
import AsiAvatar from "@/components/common/AsiAvatar.vue";

@Component({
	components: {AsiAvatar, AsiFadeTransition, AsiBtn},
})
export default class AsiPageTitle extends Vue {

	@Prop({type: String, default: null})
	public title!: string | null;

	@Prop({type: String, default: null})
	public subtitle!: string | null;

	@Prop({type: String, default: null})
	public icon!: string | null;

	@Prop({type: String, default: null})
	public avatarUrl!: string | null;

	@Prop({type: Boolean, default: false})
	public loading!: boolean;

	@Prop({type: Boolean, default: true})
	public showCreate!: boolean;

	@Prop({type: Boolean, default: true})
	public showMenuActions!: boolean;

	private icons = Icon;

	private get hasCreateListener(): boolean {
		return !!this.$listeners.create;
	}

	private get hasMenuActions(): boolean {
		return !!this.$slots['menu-actions'];
	}

	@Emit('create')
	public create(event: Event): Event {
		return event;
	}

}
